import { createFileRoute } from "@tanstack/react-router";
import { InstantNotificationPage } from "@/features/user-setting/components/InstantNotificationPage";

export const Route = createFileRoute("/settings/instant-notification")({
  component: InstantNotificationPage,
});
